// :cow: Cosmose CONFIDENTIAL :iso:
import { HttpContext, HttpContextToken } from '@angular/common/http';

export const SKIP_AUTHORIZATION = new HttpContextToken<boolean>(() => false);

export function skipAuthorizationContext(): HttpContext {
  return new HttpContext().set(SKIP_AUTHORIZATION, true);
}
